import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const ProvisionalTravelers = React.lazy(() => import("./ProvisionalTravelers"));

function ProvisionalTravelersPage(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "provisionalTravelers.pageTitle",
      defaultValue: "Smart Portal - Provisional Travelers",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "provisionalTravelers.loadingPage",
            defaultValue: "Loading Provisional Travelers",
          })}
        />
      }
    >
      <ProvisionalTravelers {...props} key={props.location.search} />
    </Suspense>
  );
}

export default ProvisionalTravelersPage;
